/**
 * components/assistant/HseAiIcon.js — ХАБЭА ТУСЛАХЫН ДҮРС.
 *
 * Хэрэглэгч (2026-11-04): HSE-ийн гурван цагираг (Health · Environment ·
 * Safety) шиг, AI-д тохирсон дүрс. Улаан = эрүүл мэнд, ногоон = байгаль
 * орчин, шар = аюулгүй байдал; голд нь «AI», дээд буланд AI-ийн оч.
 * Цагаан дэвсгэр дээр хамгийн тод — товч, аватарт цагаан дугуйд хийнэ.
 */
import React from "react";

export default function HseAiIcon({ size = 28, title }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 64 64"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : "true"}
      aria-label={title}
      focusable="false"
    >
      <circle cx="21" cy="40" r="15" fill="none" stroke="#16A34A" strokeWidth="6" />
      <circle cx="43" cy="40" r="15" fill="none" stroke="#FACC15" strokeWidth="6" />
      <circle cx="32" cy="22" r="15" fill="none" stroke="#E11D2E" strokeWidth="6" />
      <circle cx="32" cy="35" r="10.5" fill="#fff" />
      <text
        x="32"
        y="39.6"
        textAnchor="middle"
        fontFamily="Arial, Helvetica, sans-serif"
        fontSize="12.5"
        fontWeight="800"
        fill="#374151"
      >
        AI
      </text>
      <path
        d="M51 6 l1.6 3.4 3.4 1.6 -3.4 1.6 -1.6 3.4 -1.6 -3.4 -3.4 -1.6 3.4 -1.6z"
        fill="#0891B2"
      />
    </svg>
  );
}
